import { z } from "zod";
export const environmentSchema = z.enum(["dev", "stage", "prod"]);
export const workflowContextSchema = z
    .object({
    workflowId: z.string().min(1).max(100),
    environment: environmentSchema,
    requestId: z.string().min(1).max(128),
    correlationId: z.string().min(1).max(128),
    idempotencyKey: z.string().min(1).max(200),
    organizationId: z.string().uuid(),
})
    .strict();
export const cursorPageSchema = z
    .object({
    nextCursor: z.string().min(1).nullable(),
    hasMore: z.boolean(),
})
    .strict();
export const artifactRefSchema = z
    .object({
    provider: z.literal("gcp").optional(),
    bucket: z.string().min(3).max(222),
    key: z.string().min(1).max(1024),
    generation: z.string().regex(/^\d+$/).optional(),
    step: z.string().min(1).max(80).optional(),
    contentType: z.string().min(1).max(200),
    sizeBytes: z.number().int().nonnegative(),
    checksumSha256: z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .optional(),
    schemaVersion: z
        .string()
        .regex(/^\d+\.\d+\.\d+$/)
        .optional(),
    createdAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=context.js.map